import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';
import { Step, StepIconProps, StepLabel, Stepper, Typography } from '@mui/material';
import { FC } from 'react';
import { ComplaintHistoryDTO } from '../../types/ComplaintHistoryDTO';
import { useUtils } from '../../utils/utilFunctions';

export const ComplaintTimelineInternal: FC<{history: ComplaintHistoryDTO[]}> = ({history}) => {
	const sortedHistory = Array.isArray(history)
		? [...history].sort((a, b) => a.id - b.id)
		: [];
	const activeStep = sortedHistory.length;
	const { formatStringFullDate } = useUtils();

	return (
		<div className="stepper">
			<Stepper
				activeStep={activeStep}
				orientation="vertical"
			>
				{sortedHistory.map((step) => (
					<Step key={step.id} completed={true}>
						<StepLabel StepIconComponent={ComplaintStepIcon}>
							<Typography variant="body1">
								{step.description}
							</Typography>
							{step.createdAt && (
								<Typography variant="caption" color="text.secondary">
									{formatStringFullDate(step.createdAt)}
								</Typography>
							)}
						</StepLabel>
					</Step>
				))}
			</Stepper>
		</div>
	);

	function ComplaintStepIcon(props: StepIconProps) {
		const { completed } = props;
		if (completed) {
			return <CheckCircle color="success" />;
		}
		return <RadioButtonUnchecked sx={{ color: 'grey.500' }} />;
	}
};